/* ==========================================================================
   PC-FINDER QUIZ (PERFEKT / PLAUSIBEL)
   - Step 1+2 bestimmen Mindest-Tier (Entry/Mid/Pro)
   - Budget schiebt nur nach oben (nie unrealistisch runter)
   - Bei Budget-Konflikt: klare Erklärung + Alternative-Link
   - Ergebnistext enthält neu / (Neu & Gebraucht)
   - Button-Link je Tier+Build (deine Collections)
   - Restart stabil
   ========================================================================== */
(function() {
  var quiz = document.getElementById('rg-quiz');
  if (!quiz) return;

  var answers = {};

  // Deine Ergebnis-Collections (Handles)
  var RESULT_COLLECTIONS = {
    entry: { new: 'entry-gaming-pcs-neu', mixed: 'entry-gaming-pc-neu-gebraucht' },
    mid:   { new: 'mid-range-gaming-pcs-1', mixed: 'mid-range-gaming-pcs-gebraucht-neu' },
    pro:   { new: 'pro-gaming-pcs-neu', mixed: 'pro-gaming-pcs' }
  };

  var FALLBACK_COLLECTION_HANDLE = 'alle-pcs';

  function norm(v) {
    return String(v || '').trim().toLowerCase();
  }

  function normalizeBudget(v) {
    v = norm(v);
    if (['high', 'highend', 'high-end', 'pro', 'pro pc', 'pro pcs', 'pro-pcs'].includes(v)) return 'pro';
    if (['entry', 'entry-level', 'entrygaming', 'entry gaming'].includes(v)) return 'entry';
    if (['mid', 'midrange', 'mid-range'].includes(v)) return 'mid';
    return v;
  }

  function normalizeBuild(v) {
    v = norm(v);
    if (['mixed', 'gebraucht', 'used', 'neu & gebraucht', 'neu-und-gebraucht', 'neu-gebraucht'].includes(v)) return 'mixed';
    if (['new', 'neu', '100% neu', '100 % neu'].includes(v)) return 'new';
    return v;
  }

  function showStep(step) {
    quiz.querySelectorAll('.rg-finder__step').forEach(function(s) {
      s.classList.remove('active');
      s.setAttribute('aria-hidden', 'true');
    });
    step.classList.add('active');
    step.removeAttribute('aria-hidden');

    var firstBtn = step.querySelector('button, a');
    if (firstBtn) firstBtn.focus();
  }

  function buildResultUrl(tierKey, buildKey) {
    tierKey = tierKey || 'mid';
    buildKey = (buildKey === 'new' || buildKey === 'mixed') ? buildKey : 'mixed';

    var handle =
      (RESULT_COLLECTIONS[tierKey] && RESULT_COLLECTIONS[tierKey][buildKey])
        ? String(RESULT_COLLECTIONS[tierKey][buildKey]).trim()
        : '';

    if (handle) return '/collections/' + handle;
    return '/collections/' + FALLBACK_COLLECTION_HANDLE;
  }

  function tierLabel(tierKey) {
    if (tierKey === 'entry') return 'Entry Gaming';
    if (tierKey === 'pro') return 'PRO PCs';
    return 'Mid-Range';
  }

  function tierSuffix(buildType) {
    return (buildType === 'new') ? ' neu' : ' (Neu & Gebraucht)';
  }

  // Mindest-Tier aus Games + Auflösung (realistisch)
  function baseTierFromNeeds(gameType, resType) {
    // 4k oder High-End Wunsch => Pro
    if (resType === '4k' || gameType === 'highend') return 'pro';
    // 1440p oder AAA => Mid
    if (resType === '1440p' || gameType === 'aaa') return 'mid';
    // 1080p casual => Entry
    return 'entry';
  }

  // Budget zu Tier als grobe Richtwerte (nur für Hinweistext)
  function budgetRangeText(budgetKey) {
    if (budgetKey === 'entry') return 'bis ca. 500€';
    if (budgetKey === 'mid') return 'ca. 500€–900€';
    if (budgetKey === 'pro') return 'ab ca. 900€';
    return '';
  }

  function handleOption(btn) {
    var current = btn.closest('.rg-finder__step');
    if (!current) return;

    var step = current.dataset.step;
    answers[step] = btn.dataset.value;

    var next = current.nextElementSibling;
    if (next && next.dataset.step !== 'result') {
      showStep(next);
    } else {
      showResult();
    }
  }

  function showResult() {
    var resultStep = quiz.querySelector('[data-step="result"]');

    // Deine Step-Values:
    // Step1: casual/aaa/highend
    // Step2: 1080p/1440p/4k
    // Step3: entry/mid/pro
    // Step4: mixed/new
    var gameType = norm(answers['1']);
    var resType = norm(answers['2']);
    var budgetKey = normalizeBudget(answers['3']);
    var buildType = normalizeBuild(answers['4']);

    if (buildType !== 'new' && buildType !== 'mixed') buildType = 'mixed';
    if (budgetKey !== 'entry' && budgetKey !== 'mid' && budgetKey !== 'pro') budgetKey = 'mid';

    // 1) Mindest-Tier aus Bedarf
    var baseTier = baseTierFromNeeds(gameType, resType);

    // 2) Budget darf nach oben schieben, aber nie unter baseTier drücken
    var tierKey = baseTier;

    // Budget nach oben:
    if (budgetKey === 'pro') tierKey = 'pro';
    else if (budgetKey === 'mid' && tierKey === 'entry') tierKey = 'mid';

    // Mindest-Tier absichern (falls oben überschrieben)
    if (baseTier === 'pro') tierKey = 'pro';
    if (baseTier === 'mid' && tierKey === 'entry') tierKey = 'mid';

    // Link für Hauptbutton
    var link = buildResultUrl(tierKey, buildType);

    // Alternative (wenn Budget unter baseTier liegt)
    var hasBudgetConflict = false;
    if (baseTier === 'pro' && budgetKey !== 'pro') hasBudgetConflict = true;
    if (baseTier === 'mid' && budgetKey === 'entry') hasBudgetConflict = true;

    var altTierKey = null;
    if (hasBudgetConflict) {
      // Alternative: eine Stufe runter (pro->mid, mid->entry)
      altTierKey = (baseTier === 'pro') ? 'mid' : 'entry';
    }

    // Beschreibungstexte
    var desc = '';
    if (tierKey === 'entry') {
      desc = 'Solider Einstieg für 1080p-Gaming und E-Sports Titel.';
    } else if (tierKey === 'mid') {
      desc = 'Beste Balance aus Preis und Leistung — stark für 1080p/1440p und viele AAA-Titel.';
    } else {
      desc = 'Kompromisslose Leistung für 1440p, hohe Settings und anspruchsvolle Games.';
    }

    if (buildType === 'new') {
      desc += ' Ausschließlich neue Komponenten mit voller Herstellergarantie.';
    } else {
      desc += ' Preisoptimiert mit geprüften, hochwertigen Gebrauchtteilen.';
    }

if (hasBudgetConflict) {
  desc += '<br><br><strong style="color:#ffffff;">Hinweis:</strong> Deine Auswahl ('
    + (resType === '4k' ? '1440P / 4K' : (resType === '1440p' ? '1440p' : '1080p'))
    + (gameType
        ? ', ' + (gameType === 'highend' ? 'Ultra / Streaming' : (gameType === 'aaa' ? 'AAA' : 'Casual'))
        : '')
    + ') passt typischerweise eher zu '
    + tierLabel(baseTier)
    + ' ('
    + budgetRangeText(baseTier === 'pro' ? 'pro' : (baseTier === 'mid' ? 'mid' : 'entry'))
    + ').';

  if (altTierKey) {
    desc += '<br><strong style="color:#ffffff;">Alternative:</strong> Wenn du beim Budget bleiben willst, schau dir auch '
      + tierLabel(altTierKey)
      + ' an.';
  }
}


    // Ausgabe
    var tierEl = document.getElementById('rg-quiz-tier');
    var descEl = document.getElementById('rg-quiz-desc');
    var linkEl = document.getElementById('rg-quiz-link');

    var tierText = tierLabel(tierKey) + tierSuffix(buildType);

    if (tierEl) tierEl.textContent = tierText;
    if (descEl) descEl.innerHTML = desc;
    if (linkEl) linkEl.href = link || ('/collections/' + FALLBACK_COLLECTION_HANDLE);

    // OPTIONAL: zweiten Button als Alternative einblenden (ohne HTML umbauen: wir erstellen ihn)
    // Wenn du keinen zweiten Button willst: diesen Block löschen.
    var resultBox = document.getElementById('rg-quiz-result');
    var existingAlt = document.getElementById('rg-quiz-alt-link');

    if (existingAlt) existingAlt.remove();

    if (hasBudgetConflict && altTierKey && resultBox) {
      var altUrl = buildResultUrl(altTierKey, buildType);

      var a = document.createElement('a');
      a.id = 'rg-quiz-alt-link';
      a.href = altUrl;
      a.className = 'button rg-hero__btn rg-hero__btn--secondary';
      a.style.marginLeft = '10px';
      a.textContent = tierLabel(altTierKey) + ' ansehen';
      resultBox.insertBefore(a, resultBox.querySelector('.rg-finder__restart'));
    }

    showStep(resultStep);
  }

  function restart() {
    Object.keys(answers).forEach(function(k) { delete answers[k]; });
    var alt = document.getElementById('rg-quiz-alt-link');
    if (alt) alt.remove();
    showStep(quiz.querySelector('[data-step="1"]'));
  }

  quiz.querySelectorAll('.rg-finder__step:not(.active)').forEach(function(s) {
    s.setAttribute('aria-hidden', 'true');
  });

  quiz.addEventListener('click', function(e) {
    var optionBtn = e.target.closest('.rg-finder__option');
    var restartBtn = e.target.closest('.rg-finder__restart');
    if (optionBtn) handleOption(optionBtn);
    if (restartBtn) restart();
  });

  quiz.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var optionBtn = e.target.closest('.rg-finder__option');
      var restartBtn = e.target.closest('.rg-finder__restart');
      if (optionBtn) { e.preventDefault(); handleOption(optionBtn); }
      if (restartBtn) { e.preventDefault(); restart(); }
    }
  });
})();